import type { AntecedenceTime, GetSearchLocation } from '../types';

export const isInternationalAgency = (agency: GetSearchLocation | null) => {
  if (agency) {
    const { region } = agency;

    return region === 'international';
  }

  return agency;
};

export const isAirportAgency = (agency: GetSearchLocation | null) => {
  if (agency) {
    const { regionType } = agency;

    return regionType === 'airport';
  }

  return agency;
};

export const getAntecedenceByInternationality = (antecedenceTime: AntecedenceTime, isInternational: boolean | null) => {
  if (typeof isInternational === 'boolean') {
    const { international, national } = antecedenceTime;

    return isInternational ? international : national;
  }

  return 0;
};
